import { useEffect, useState } from "react";
import { http } from "../lib/auth";
import { BookingProvider } from "../lib/booking";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import Atelier from "../components/site/Atelier";
import TheTeam from "../components/site/TheTeam";
import Services from "../components/site/Services";
import Gallery from "../components/site/Gallery";
import Visit from "../components/site/Visit";
import Footer from "../components/site/Footer";

export default function Site() {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [s, sv, g] = await Promise.all([
          http.get("/public/settings"),
          http.get("/public/services"),
          http.get("/public/gallery"),
        ]);
        if (!alive) return;
        setSettings(s.data);
        setServices(sv.data);
        setGallery(g.data);
      } catch (e) {
        console.error("[site] failed to load public content:", e);
        if (alive) setError("Could not load site content.");
      }
    })();
    return () => { alive = false; };
  }, []);

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--fs-ink)" }}>
        <p data-testid="site-error">{error}</p>
      </div>
    );
  }
  if (!settings) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <div className="fs-overline" style={{ color: "var(--fs-caramel)" }}>Loading…</div>
      </div>
    );
  }

  return (
    <BookingProvider settings={settings}>
      <div className="fs-grain" data-testid="public-site">
        <Header settings={settings} />
        <main>
          <Hero settings={settings} />
          <Marquee items={settings.marquee_items} />
          <Atelier settings={settings} />
          <Services services={services} settings={settings} />
          <Gallery items={gallery} />
          <TheTeam />
          <Visit settings={settings} />
        </main>
        <Footer settings={settings} services={services} />
      </div>
    </BookingProvider>
  );
}
